import React from 'react'
import { Button, useModal, theme, Group, useNotification } from '@fortressiq/fiq-ds'
import api from 'lib/Api'
import SwitchSection from '../../tenants/SwitchSection'

const IpWhitelistToggle = ({
  ipToggleStatus,
  whitelistStatus,
  handleReFetch,
  setIpToggleStatus,
  setWhitelistStatus,
}) => {
  const modalConfig = {
    footer: false,
    style: { height: 'auto', width: '400px' },
    config: { interactWithKeyboard: false, destroyOnClose: true },
    headerStyle: { background: theme.white },
  }
  const { addModal, removeModal } = useModal()
  const { addNotification } = useNotification()

  /* istanbul ignore next */
  const handleDiableAllIPs = async () => {
    try {
      removeModal()
      const { data } = await api.patch('/ip_addresses/ip_whitelist_enabled', { ip_whitelist_enabled: !whitelistStatus })
      if (!data) handleReFetch()
    } catch (error) {
      addNotification({
        description: error.message || 'An error occurred',
        message: 'Error',
        type: 'error',
      })
    }
  }
  /* istanbul ignore next */
  const openModal = value => {
    setIpToggleStatus(value)
    addModal({
      children: (
        <React.Fragment>
          <p>
            {whitelistStatus
              ? 'Please note you are disabling IP Allow List which will expose you to data from IP addresses not configured. All current IP addresses on this list will be permanently disabled.'
              : 'Please note you are Enabling IP Allow List for improved security. After enabling you will need to add IP addresses, verify and activate them. You will need to verify the IP address from the same IP address you are adding to this list. Note any previous IP addresses configured will remain in "Inactive" state.'}
          </p>
          <Group noEndGutter={true} justify='flex-end' style={{ marginTop: theme['default-spacer-md'] }}>
            <Button
              onClick={e => {
                e.preventDefault()
                setWhitelistStatus(whitelistStatus)
                setIpToggleStatus(!value)
                removeModal()
              }}
            >
              No
            </Button>
            <Button className='yesBtn' type='primary' onClick={() => handleDiableAllIPs()}>
              Yes
            </Button>
          </Group>
        </React.Fragment>
      ),
      closable: false,
      header: 'Are you sure?',
      id: 'ipWhitelistStatus',
      ...modalConfig,
    })
  }
  return (
    <SwitchSection
      label='IP Allow List'
      id='ipWhitelist'
      checked={ipToggleStatus}
      onSwitch={({ SWITCH_STATE }) => openModal(SWITCH_STATE)}
      size='small'
      style={{ margin: '0' }}
      key='ipWhitelist'
      className='ipWhitelistToggle'
    />
  )
}

export default IpWhitelistToggle
